import React from 'react';

import { getObjectTileSizes } from '../get-object-tile-sizes';
import { getObjectTiles } from '../helpers';
import type { ObjectTileData } from '../types';

import { BaseExplorer } from './base-explorer';

type ObjectTileExplorerProps = {
	testId?: string;
};

export function ObjectTileExplorer({ testId }: ObjectTileExplorerProps): React.JSX.Element {
	return (
		<BaseExplorer<ObjectTileData>
			testId={testId}
			isObjectTile
			getObjects={getObjectTiles}
			getSizes={getObjectTileSizes}
		/>
	);
}
